export default __webpack_public_path__ + "static/media/venti-views-1cqIcrWFQBI-unsplash Large.3d7e9b6e.jpg";